var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.5C11.9489 4.5 12.1397 4.57902 12.2803 4.71967C12.421 4.86032 12.5 5.05109 12.5 5.25V11H18.25C18.4489 11 18.6397 11.079 18.7803 11.2197C18.921 11.3603 19 11.5511 19 11.75C19 11.9489 18.921 12.1397 18.7803 12.2803C18.6397 12.421 18.4489 12.5 18.25 12.5H12.5V18.25C12.5 18.4489 12.421 18.6397 12.2803 18.7803C12.1397 18.921 11.9489 19 11.75 19C11.5511 19 11.3603 18.921 11.2197 18.7803C11.079 18.6397 11 18.4489 11 18.25V12.5H5.25C5.05109 12.5 4.86032 12.421 4.71967 12.2803C4.57902 12.1397 4.5 11.9489 4.5 11.75C4.5 11.5511 4.57902 11.3603 4.71967 11.2197C4.86032 11.079 5.05109 11 5.25 11H11V5.25C11 5.05109 11.079 4.86032 11.2197 4.71967C11.3603 4.57902 11.5511 4.5 11.75 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.a77bdc9fecaee42d81c345ca585bbeee.svg";
export { ForwardRef as ReactComponent };